import { isEmpty, trim } from 'lodash';

export function getCustomerName(fields) {
  if (!isEmpty(fields.firstName)) {
    return trim(`${fields.firstName} ${fields.lastName}`);
  }

  return fields.name;
}
